<script setup>
const gsapTimeline = useGsapTimeline()
const outlineTextElement = ref(null)
const outlineTextElementChildren = ref(null)

const textElement = ref(null)
const textElementChildren = ref(null)

defineProps({
  text: String,
  textSizeClass: {
    // This is a temporary workaround that must be refactored to something more maintainable
    type: String,
    default: 'text-[85px]',
  },
  textOutlineSizeClass: {
    // This is a temporary workaround that must be refactored to something more maintainable
    type: String,
    default: 'text-[140px]',
  },
})

const emit = defineEmits(['timeline'])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'CharacterJumpFromTheRight' })
    .startInvisible([outlineTextElement, textElement])
    .fromTo(
      outlineTextElementChildren.value.slice(1),
      { visibility: 'hidden', x: 100, y: -100 },
      { visibility: 'inherit', x: 0, y: 0, duration: 0.12, stagger: { amount: 0.24 }, ease: 'back.in(1.7)' }
    )
    .from(outlineTextElement, { x: -50, duration: 0.36 }, '<')
    .fromTo(outlineTextElementChildren, { paddingRight: 30 }, { paddingRight: 0, duration: 0.36 }, '<')

    .fromTo(textElementChildren.value, { visibility: 'hidden', x: 100, y: -100 }, { visibility: 'inherit', x: 0, y: 0, duration: 0.12, stagger: { amount: 0.24 }, ease: 'back.in(1.7)' }, '<.2')
    .from(textElement, { x: -50, duration: 0.36 }, '<')
    .fromTo(textElementChildren, { paddingRight: 30 }, { paddingRight: 0, duration: 0.36 }, '<')

    .to(outlineTextElement, { visibility: 'hidden' }, '<.32')

    .fromTo(shuffle(textElementChildren), { scale: 1.2, transformOrigin: 'bottom center' }, { scale: 1, duration: 0.16, stagger: { amount: 0.16 }, ease: 'power2.inOut' }, '<')

  emit('timeline', timeline)
})
</script>

<template>
  <div class="relative font-cervo font-bold">
    <SplitCharacters ref="textElement" :text="text" :class="['items-end invisible', textSizeClass]" />
    <SplitCharacters ref="textElement" :text="text" :class="['items-end absolute bottom-0', textSizeClass]" @container="textElement = $event" @children="textElementChildren = $event" />
    <div :class="['absolute bottom-0 text-transparent text-stroke-2 text-stroke-white tracking-[-.11em] -mb-2 w-[150%]', textOutlineSizeClass]">
      <SplitCharacters ref="outlineTextElement" :text="text" @container="outlineTextElement = $event" @children="outlineTextElementChildren = $event" />
    </div>
  </div>
</template>
